<template>
  <div class="container">
    <div class="container-top">
      <img :src="this.publicData.serverUrl + 'images/sta.png'" alt="" />
    </div>
    <div class="container-classify">
      <el-select
        v-model="classify"
        :placeholder="$t('lang.external.fzsy.请选择')"
      >
        <el-option
          v-for="item in classifys"
          :key="item.label"
          v-show="item.id !== classify"
          :label="item.label"
          :value="item.id"
        >
        </el-option>
      </el-select>
    </div>
    <div class="main">
      <div
        class="main-item"
        v-for="item in productions"
        :key="item.id"
        @click="setExp(item.id)"
      >
        <img :src="item.cover" alt="" />
        <div class="main-item-info">
          <p>{{ item.title }}</p>
          <div class="main-item-info-rate">
            {{ item.kps }}
            <el-rate
              disabled
              :value="item.kps"
              :colors="['#A63528', '#A63528', '#A63528']"
            />
          </div>
          <div class="main-item-info-status">
            <div class="main-item-info-status-item comment">
              <i class="el-icon-chat-dot-square"></i>
              {{ item.comment }}
            </div>
            <div class="main-item-info-status-item">
              <i class="el-icon-view"></i>
              {{ item.view }}
            </div>
          </div>
        </div>
      </div>
      <el-empty
        v-if="!productions.length"
        :description="$t('lang.external.fzsy.暂无数据！')"
      ></el-empty>
    </div>
  </div>
</template>

<script>
import { expList, expCategory } from '@/api/simulation/index'
import { formatLan } from '@/utils/lanFormat'
export default {
  name: 'simulation',
  components: {},
  props: [],
  data() {
    return {
      classify: this.$t('lang.external.fzsy.全部分类'),
      classifys: [],
      productions: [],
    }
  },
  watch: {
    classify() {
      this.getProductions()
    },
  },
  computed: {},
  created() {
    this.getCategory()
    this.getProductions()
  },
  mounted() {
    this.reload()
  },
  methods: {
    getProductions() {
      const productions = []
      let classify = ''
      classify = this.classify
      if (this.classify === this.$t('lang.external.fzsy.全部分类'))
        classify = ''
      expList({ classify_id: classify }).then((res) => {
        const { data } = res.data
        // console.log(res)
        data.forEach((v, i) => {
          productions.push({
            id: v.id,
            cover: v.courseImg,
            title: formatLan(v.courseName),
            comment: v.comment_count,
            view: v.viewCount,
            kps: parseFloat(v.score),
          })
        })
        this.productions = productions
      })
    },
    reload() {
      if (location.href.indexOf('#reloaded') == -1) {
        location.href = location.href + '#reloaded'
        location.reload()
      }
    },
    getCategory() {
      const classifys = [
        {
          id: this.$t('lang.external.fzsy.全部分类'),
          label: this.$t('lang.external.fzsy.全部分类'),
        },
      ]
      expCategory().then((res) => {
        const { data } = res
        data.forEach((v, i) => {
          classifys.push({
            id: v.id,
            label: formatLan(v.classifyName),
          })
        })
        this.classifys = classifys
      })
    },
    setExp(id) {
      window.localStorage.setItem('expId', id)
      this.$router.push({ name: 'Experiment', query: { id } })
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  color: #666666;
  p {
    margin: 0;
  }
  &-top {
    height: 40vh;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &-classify {
    width: 100%;
    padding: 0 18%;
    background-color: white;
    ::v-deep .el-input__inner {
      border: none;
      color: #666666;
      font-size: 0.9375vw;
    }
  }
  .main {
    width: 100%;
    padding: 20px 18%;
    display: flex;
    flex-flow: wrap;
    &-item {
      width: calc(25% - 20px);
      display: flex;
      flex-direction: column;
      margin-right: 20px;
      margin-top: 20px;
      color: #666666;
      background: #ffffff;
      box-shadow: 3px 5px 6px 0px rgba(25, 59, 83, 0.2);
      border-radius: 10px;
      cursor: pointer;
      &:first-child {
        margin-left: 0;
      }
      img {
        width: 100%;
        height: 12rem;
        border-radius: 10px 10px 0px 0px;
      }
      &-info {
        p {
          padding: 10px 15px;
          color: #666666;
        }
        &-rate {
          display: flex;
          padding: 10px 15px;
          padding-top: 0;
        }
        &-status {
          display: flex;
          justify-content: space-between;
          border-top: 1px solid #d7d7d7;
          color: #999999;
          &-item {
            width: 50%;
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding: 10px 15px;
            i {
              font-size: large;
            }
          }
          .comment {
            border-right: 1px solid #d7d7d7;
          }
        }
      }
    }
    .el-empty {
      width: 100%;
      height: 36vh;
    }
  }
}
::v-deep .el-select-dropdown__list {
  background-color: #f8f8f8;
}
::v-deep .el-select-dropdown__item {
  color: #666666;
  font-size: 0.9375vw;
  height: 45px;
  box-shadow: 3px 5px 6px 0px rgba(25, 59, 83, 0.2);
}
::v-deep .el-select-dropdown__item.hover,
.el-select-dropdown__item:hover {
  color: #ffffff !important;
  background-color: #a63528 !important;
}
::v-deep .el-select .el-input .el-select__caret {
  color: #0c5893;
  font-weight: bold;
}
</style>